import React from "react";
import { Header } from "../../components/Header/Headers";
import VehicleList from "./Components";

const RegisteredVehicles: React.FC = () => {
  return (
    <>
      <Header
        title="Registered Vehicles"
        breadcrumb="Admin Console / Registered Vehicles"
      />
      <VehicleList />
    </>
  );
};

export default RegisteredVehicles;
